import type {
    AggregationFnDef,
    AggregationFnOption,
    RowData,
} from "@tanstack/react-table";
import { isFiniteNumber } from "../cells/cellValues";
import type { DataGridAggregate } from "../columns/types";
import type { DataGridFeatures } from "../features";

/**
 * Maps a column's `aggregate` to its TanStack `aggregationFn`. Columns
 * without one get none, so group rows leave them blank instead of summing
 * every numeric column.
 */
export const toAggregationFn = <TData extends RowData>(
    aggregate: DataGridAggregate | undefined,
): AggregationFnOption<DataGridFeatures, TData> | undefined => {
    if (aggregate === undefined || typeof aggregate === "string") {
        return aggregate;
    }
    const custom: AggregationFnDef<DataGridFeatures, TData> = {
        aggregate: ({ rows, getValue }) =>
            aggregate(rows.map(getValue).filter(isFiniteNumber)),
    };
    return custom;
};
